export default () => ({
  groupQuestionContainer: {
    marginBottom: 16,
  },
  groupQuestionName: {
    marginBottom: 16,
    fontSize: 16,
    fontFamily: 'Roboto-Bold'
  },
})